import { cn } from "@/lib/utils";

const BADGE = {
  confirmed:        "bg-emerald-50 text-emerald-700 border-emerald-200/80 dark:bg-emerald-950/40 dark:text-emerald-400 dark:border-emerald-800/50",
  pending:          "bg-amber-50  text-amber-700  border-amber-200/80  dark:bg-amber-950/40  dark:text-amber-400  dark:border-amber-800/50",
  pending_approval: "bg-amber-50  text-amber-700  border-amber-200/80  dark:bg-amber-950/40  dark:text-amber-400  dark:border-amber-800/50",
  cancelled:        "bg-red-50    text-red-600    border-red-200/80    dark:bg-red-950/40    dark:text-red-400    dark:border-red-800/50",
  rejected:         "bg-red-50    text-red-600    border-red-200/80    dark:bg-red-950/40    dark:text-red-400    dark:border-red-800/50",
  waitlist:         "bg-blue-50   text-blue-700   border-blue-200/80   dark:bg-blue-950/40   dark:text-blue-400   dark:border-blue-800/50",
  published:        "bg-emerald-50 text-emerald-700 border-emerald-200/80 dark:bg-emerald-950/40 dark:text-emerald-400 dark:border-emerald-800/50",
  approved:         "bg-blue-50   text-blue-700   border-blue-200/80   dark:bg-blue-950/40   dark:text-blue-400   dark:border-blue-800/50",
  public:           "bg-emerald-50 text-emerald-700 border-emerald-200/80 dark:bg-emerald-950/40 dark:text-emerald-400",
  internal:         "bg-slate-50  text-slate-600  border-slate-200/80  dark:bg-slate-800     dark:text-slate-400",
  private:          "bg-slate-50  text-slate-600  border-slate-200/80  dark:bg-slate-800     dark:text-slate-400",
  active:           "bg-emerald-50 text-emerald-700 border-emerald-200/80",
  maintenance:      "bg-orange-50 text-orange-700 border-orange-200/80",
  inactive:         "bg-slate-50  text-slate-500  border-slate-200/80",
  pending_review:   "bg-amber-50  text-amber-700  border-amber-200/80",
};
const DEFAULT_BADGE = "bg-slate-50 text-slate-600 border-slate-200/80 dark:bg-slate-800 dark:text-slate-400";

const DOT = {
  confirmed: "bg-emerald-500", pending: "bg-amber-500", pending_approval: "bg-amber-500",
  cancelled: "bg-red-500", rejected: "bg-red-500", waitlist: "bg-blue-500",
  published: "bg-emerald-500", approved: "bg-blue-500", public: "bg-emerald-500",
  active: "bg-emerald-500", maintenance: "bg-orange-500",
};

export default function Badge({ status, label, dot = true, className }) {
  const s = status?.toLowerCase();
  const cls = BADGE[s] || DEFAULT_BADGE;
  const dc  = DOT[s] || "bg-slate-400";
  const text = label ?? (status?.replace(/_/g, " ") || "—");
  return (
    <span className={cn("inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-semibold border leading-none capitalize", cls, className)}>
      {dot && <span className={cn("w-1.5 h-1.5 rounded-full shrink-0", dc)} />}
      {text}
    </span>
  );
}
